<template>
  <nav v-if="breadcrumbs.length > 1" class="mb-6" aria-label="Breadcrumb">
    <ol class="flex items-center space-x-2 text-sm">
      <li
        v-for="(breadcrumb, index) in breadcrumbs"
        :key="breadcrumb.path"
        class="flex items-center"
      >
        <!-- Separator -->
        <ChevronRightIcon
          v-if="index > 0"
          class="w-4 h-4 text-gray-400 dark:text-gray-500 mx-2 flex-shrink-0"
          aria-hidden="true"
        />

        <!-- Breadcrumb Item -->
        <router-link
          v-if="!breadcrumb.active"
          :to="breadcrumb.path"
          class="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors duration-200 flex items-center"
          :aria-current="index === breadcrumbs.length - 1 ? 'page' : undefined"
        >
          <span class="truncate max-w-32 sm:max-w-48">{{ breadcrumb.label }}</span>
        </router-link>

        <!-- Current Page (not clickable) -->
        <span
          v-else
          class="text-gray-900 dark:text-gray-50 font-medium truncate max-w-32 sm:max-w-48"
          aria-current="page"
        >
          {{ breadcrumb.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { ChevronRightIcon } from '@heroicons/vue/24/outline'
  import { useDocumentationStore } from '@/stores/documentation'

  // Store
  const documentationStore = useDocumentationStore()

  // Computed
  const breadcrumbs = computed(() => documentationStore.getBreadcrumbs)
</script>

<style scoped>
  /* Ensure breadcrumbs don't overflow on small screens */
  @media (max-width: 640px) {
    .max-w-32 {
      max-width: 8rem;
    }
  }

  @media (min-width: 640px) {
    .max-w-48 {
      max-width: 12rem;
    }
  }
</style>
